import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import ExpandableOrdersTable from "./ExpandableOrdersTable";

const PendingOrdersDialog = ({ open, onClose, orders, type, bay }) => {
  const title = `Pending ${type === "picking" ? "Picking" : "Packing"} Order${
    orders.length !== 1 ? "s" : ""
  }`;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          minHeight: 400,
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "#f5f5f5",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Typography variant="h6" component="div">
          {title}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontSize: "1rem", mt: 3, mb: 1 }}
        >
          Bay: <strong>{bay}</strong>
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontSize: "1rem" }}
        >
          Total Order{orders.length !== 1 ? "s" : ""}:
          <strong> {orders.length}</strong>
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ padding: 0 }}>
        <Box sx={{ width: "100%" }}>
          <ExpandableOrdersTable orders={orders} type={type} />
        </Box>
      </DialogContent>

      <DialogActions sx={{ padding: 2 }}>
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PendingOrdersDialog;
